import React from "react";
import { useSelector } from "react-redux";
import { selectAcciones } from "../reducers/authSlice";

const Accion = (props) => {
  const acciones = useSelector(selectAcciones);

  let mostrar = false;

  for (let index = 0; index < acciones.length; index++) {
    if (
      acciones[index].funcion === props.funcion &&
      acciones[index].accion === props.accion
    ) {
      mostrar = true;
      break;
    }
  }

  return <>{mostrar ? props.children : ""}</>;
};

export default Accion;
